import { buildServiceKey, buildSystemConfig } from '../app/helpers/securityUtils';

export const environment = {
  production: false,
  baseHref: '/seguros/movilidad/motos/',
  PATTERN_EMAIL: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-]+)\.([a-zA-Z]{2,9})(\.[a-zA-Z]{2,3}){0,2}$/,
  PATTERN_CELULAR: /^3(0[0-7]|1\d|2[0-4]|50)\d{7}$/,
  PATTERN_PLACA: /^[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}$/,
  PATTERN_IDENTIFICACION: /^[0-9]{7,11}$/,

  // Configuración de tiempos de inactividad (en milisegundos)
  FIRST_INACTIVITY_TIME: 60 * 5 * 1000, // 10 minutos para la primera inactividad
  SECOND_INACTIVITY_TIME: 60 * 6 * 1000, // 15 minutos para la segunda inactividad

  // DEPRECATED: Usar FIRST_INACTIVITY_TIME y SECOND_INACTIVITY_TIME
  LOCAL_TIMER: 60 * 5 * 1000,

  // URL_API_DETINOS: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/catalogos/zonas",
  // URL_API_PLANES: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/tarifas/planes",
  // URL_CIUDADES: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/catalogos/ciudades",
  // URL_CREAR_LEAD: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/clientes/motos/leadMovilidad",
  // URL_COTIZACION: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/clientes/motos/cotizacion",
  // URL_PAISES: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/catalogos/paises",
  // URL_ACTUALIZAR_LEAD: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/clientes/motos/updateLead",
  // URL_GENERAR_URL: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/clientes/motos/pago",
  // URL_MULESOFT_EXCEPTION: "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/clientes/exceptionMovilidad",

  // varabalees para banner de cash back
  bannerEnabled: true,
  bannerStartDate: '2026-09-21T00:00:00-05:00',
  bannerEndDate: '2026-09-30T23:59:00-05:00',
  banner_discount_message: 'Rueda protegido y recibe hasta $70.000 en Nequi por la compra de tu Seguro de moto. Válido hasta el 30 de septiembre.',
  bannerTitleLine1: 'Tu moto protegida +',
  bannerTitleLine2: 'cashback incluido',
  bannerImgDesktop: './assets/img/moto_pc.jpg',
  bannerImgMobile: './assets/img/moto_cel.jpg',

  pseDisabledOptionStartDate: '2026-08-07T01:00:00-05:00',
  pseDisabledOptionEndDate: '2026-08-10T06:00:00-05:00',

  // Configuración de autenticación con fragmentos de seguridad
  auth: {
    tokenEndpoint: 'security/token',
    // Fragmentos del identificador de cliente - NO MODIFICAR EL ORDEN
    clientApiKey: 'a490901c-f84b-4d86',
    clientServiceToken: '-93e1-b07d4e59',
    clientConfigHash: '47c7',
    grantType: 'client_credentials',
    scope: '2ff814a6-3304-4ab8-85cb-cd0e6f879c1d/.default',
    // Fragmentos de la clave secreta del servicio - NO MODIFICAR EL ORDEN
    servicePrefix: 'Stm8Q~WDQ6TXzao6RC~R',
    serviceCore: 'NHCknrAyeRLCv8c',
    serviceSuffix: 'WycL1',
    renewBeforeExpirationSeconds: 60,
    cookieKey: 'motosAuthTokenUat',
    cookieExpiryDateKey: 'motosTokenExpiryDateUat',
    // Getter para obtener clientId completo
    get clientId() {
      return buildSystemConfig(this.clientApiKey, this.clientServiceToken, this.clientConfigHash);
    },
    // Getter para obtener clientSecret completo
    get clientSecret() {
      return buildServiceKey(this.servicePrefix, this.serviceCore, this.serviceSuffix);
    },
  },

  API_BASE_URL: 'https://integraciones-co-qa.suratech.sura.com/v1/',
  URL_API_DETINOS: 'https://integraciones-co-qa.suratech.sura.com/v1/catalogos/zonas',
  URL_API_PLANES: 'https://integraciones-co-qa.suratech.sura.com/v1/tarifas/planes',
  URL_CIUDADES: 'https://integraciones-co-qa.suratech.sura.com/v1/catalogos/ciudades',
  URL_START_SARLAFT:
    'https://integraciones-co-qa.suratech.sura.com/v1/clientes/startsarlaftevaluation',
  URL_PULLER_SARLAFT: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/pullersarlaft',
  URL_CREAR_LEAD: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/motos/leadMovilidad',
  URL_COTIZACION: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/motos/cotizacion',
  URL_PAISES: 'https://integraciones-co-qa.suratech.sura.com/v1/catalogos/paises',
  URL_ACTUALIZAR_LEAD: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/motos/updateLead',
  URL_MEMBRESIA: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/membresiaservice',
  URL_MEMBRESIA_TOKEN:
    'https://integraciones-co-qa.suratech.sura.com/v1/clientes/membresiatokenservice',
  URL_MEMBRESIA_SEGUNDO_COBRO:
    'https://integraciones-co-qa.suratech.sura.com/v1/clientes/consultaFactura',
  URL_GENERAR_URL: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/motos/pago',
  URL_MULESOFT_EXCEPTION:
    'https://integraciones-co-qa.suratech.sura.com/v1/clientes/exceptionMovilidad',
  URL_MULESOFT_ASESORES:
    'https://integraciones-co-qa.suratech.sura.com/v1/cotizacion/SURA_OrquestadorAsesores',
  URL_BANCOS: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/beneficiarios',
  URL_UPLOADFILES: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/archivos',

  URL_SECURITY_TOKEN: 'https://integraciones-co-qa.suratech.sura.com/v1/security/token',
  GENERAL_CLIENT_ID: 'e1e6734390694890a95fd3aeac423af5',

  // Configuración para disable-devtool
  disableDevTools: false,
  // Página de redirección cuando se detectan las herramientas de desarrollo
  devToolsRedirectUrl: 'https://www.sura.co/seguros/digitales',
  // Mensaje personalizado cuando se intenta usar clic derecho (opcional)
  rightClickMessage: 'Acción no permitida por seguridad',
  // Configuración MD5 para bypass seguro
  md5Config: {
    // Nombre del parámetro URL para generar has MD5
    devToolsSecretParam: 'allow_tools',
    // Palabra secreta que se convertirá en MD5 (para UAT)
    secretPhrase: 'sura-motos-uat-bypass',
    // Nombre del parámetro URL que contendrá el hash MD5
    urlParamName: 'dev_tools',
  },

  // Configuración para compatibilidad con Dynatrace RUM
  dynatraceConfig: {
    // Habilitar detección automática del agente Dynatrace
    enabled: true,
    // Tiempo de espera (ms) antes de inicializar disable-devtool
    // Permite que Dynatrace se cargue completamente primero
    initDelay: 1500,
    // Intervalo de polling cuando Dynatrace está presente (ms)
    // Más alto = menos interferencia con métricas de performance
    pollingInterval: 3000,
  },

  gtmId: 'GTM-P547FL6M',
};
